module.exports = __webpack_public_path__ + "img/dark_illu_bertrand.6e2bce54.png";